export default function AdminPageHeader({ title, description, eyebrow = "Operasional Restoran", actions, className = "" }) {
  return (
    <header className={`admin-page-header ${className}`}>
      <div className="min-w-0">
        {eyebrow && <p className="admin-eyebrow"><span aria-hidden="true" />{eyebrow}</p>}
        <h1>{title}</h1>
        {description && <p className="admin-page-description">{description}</p>}
      </div>
      {actions && <div className="admin-page-actions">{actions}</div>}
    </header>
  );
}
